// stage api by default
// let url = "https://staging.touchguide.se/api";
let url = "https://procontgstage.cloud/api";
// ui stage url
// let host = 'https://staging.touchguide.se';
let host = 'https://procontgstage.cloud';
// let socket = 'wss://staging.touchguide.se';
let socket = 'ws://procontgstage.cloud';

// prod api
if (process.env.MODE === 'prod') {
  // url = 'http://176.9.117.89:89/api';
  // url = 'https://cms.touchguide.no/api';
  url = 'https://procontg.cloud/api';
  // url = 'http://localhost:2197/api'; // TODO!
  socket = 'wss://procontg.cloud';

  // ui prod url
  host = 'https://procontg.cloud';
}
// local docker compose api
if (process.env.MODE === 'dev') {
  url = 'http://localhost:2197/api';
  // ui prod url
  host = 'http://localhost:2197';

  socket = 'ws://localhost:2197';
}

export const BASE_URL = url;

// ui url
export const UIHost = host;
export const SOCKET = socket;

export const DATE_FORMAT_HH_MM = "YYYY-MM-DDTHH:mm:ss.SSS";
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_HH = 'HH:mm:ss.SSS';
export const HOUR_FORMAT_POPUP = "HH:mm";

export const GoogleConfiguration = {
  mapOptions: { center: { lat: 63.107663919260126, lng: 16.35629337111324 }, zoom: 11, zoomControl: true, maxZoom: 22, mapId: null },
  mapsApiKey: "AIzaSyCVRVCqkvuiWFt8Gp9qV7qloAmUVQBuxSg"
};

export const socketTypes = {
  sync: 'sync',
  reload: 'reload',
  ping: 'ping',
  reloaded: "reloaded",
  restart: 'restart',
  restarted: 'restarted'
};

export const statisticTypes = {
  touchGuide: 0,
  categoryItem: 1,
  pathFinder: 2,
  category: 3,
  menu: 4,
  service: 5,
};

export const CategoryRedirect = {
  Page: 0,
  ExternalUrlPopup: 1,
  CategoryDetals: 2,
  ChildCategory: 3,
};

export const categoryRedirectNames = {
  [CategoryRedirect.Page]: 'Change page',
  [CategoryRedirect.ExternalUrlPopup]: 'Open External Url Popup',
  [CategoryRedirect.CategoryDetals]: 'Open Category Details',
  [CategoryRedirect.ChildCategory]: 'Open Child Category'
};

export const fileTypes = ['jpg', 'png', 'gif', 'mp4', 'pdf', 'txt', 'flv', 'f4v', 'avi', 'mov', 'm2v',
  'mpeg2', 'mpeg4', 'woff', 'ttf', 'bmp', 'tif', 'svg', 'thumbnail', 'ogv', 'webm', 'jpeg'
];

export const AREAS = {
  Event: {
    category: "Published",
    name: "Events",
    routeName: 'Event',
    Event: {
      read: false,
      write: false
    }
  },
  User: {
    name: "Users",
    routeName: 'User',
    category: "User",
    User: {
      read: false,
      write: false
    }
  },
  UserGroup: {
    name: "User Groups",
    routeName: 'UserGroup',
    category: "User",
    UserGroup: {
      read: false,
      write: false
    }
  },
  Shop: {
    name: "Shops",
    routeName: 'Shop',
    category: "Published",
    Shop: {
      read: false,
      write: false
    }
  },
  RestaurantAndCafe: {
    name: "Restaurants & Cafes",
    category: "Published",
    routeName: 'RestaurantAndCafe',
    RestaurantAndCafe: {
      read: false,
      write: false
    }
  },
  ServiceCompany: {
    name: "Service Companies",
    category: "Published",
    routeName: 'ServiceCompany',
    ServiceCompany: {
      read: false,
      write: false
    }
  },
  Shops: {
    name: "Shops",
    category: "Published",
    routeName: 'Shops',
    Shops: {
      read: false,
      write: false
    }
  },
  Restaurants: {
    name: "Restaurants",
    category: "Published",
    routeName: 'Restaurants',
    Restaurants: {
      read: false,
      write: false
    }
  },
  ServiceCompanies: {
    name: "ServiceCompanies",
    category: "Published",
    routeName: 'ServiceCompanies',
    ServiceCompanies: {
      read: false,
      write: false
    }
  },
  Service: {
    name: "Services",
    category: "Published",
    routeName: 'Service',
    Service: {
      read: false,
      write: false
    }
  },
  Parking: {
    name: "Parking",
    category: "Published",
    routeName: 'Parking',
    Parking: {
      read: false,
      write: false
    }
  },
  Offer: {
    name: "Offers",
    category: "Published",
    routeName: 'Offer',
    Offer: {
      read: false,
      write: false
    }
  },
  Slideshow: {
    name: "Slideshows",
    category: "Published",
    routeName: 'Slideshow',
    Slideshow: {
      read: false,
      write: false
    }
  },
  /* "SurroundingArea": {
        name: "Surrounding Area",
        category: "Published",
        routeName: 'SurroundingArea',
        'SurroundingArea': {
            read: false,
            write: false
        }
    }, */
  MediaLibrary: {
    name: "Media Library",
    category: "MediaLibrary",
    routeName: 'MediaLibrary',
    MediaLibrary: {
      read: false,
      write: false
    }
  },
  Statistic: {
    name: "Statistic",
    category: "Statistics",
    routeName: 'Statistic',
    Statistic: {
      read: false,
      write: false
    },
  },
  Mall: {
    name: "Malls",
    category: "Malls",
    routeName: 'Mall',
    Mall: {
      read: false,
      write: false
    }
  },
  Sms: {
    name: "Sms",
    category: "Malls",
    routeName: 'Sms',
    Sms: {
      read: false,
      write: false
    }
  },
  Information: {
    name: "Information",
    category: "InfoPage",
    routeName: 'Information',
    Information: {
      read: false,
      write: false
    }
  }
};
export const DASHBOARD_ITEMS = {
  Event: {
    itemColor: 'dashboard-color-1',
    headline: 'Events',
    headlineIco: 'icon-player',
    numberOfItems: '0',
    topInfo: 'active',
    bottomInfo: '0 inactive',
    url: '/published/event',
    enable: false
  },
  Shop: {
    itemColor: 'dashboard-color-2',
    headline: 'Shops',
    headlineIco: 'icon-form-1',
    numberOfItems: '0',
    topInfo: '',
    bottomInfo: 'in 0 categories',
    url: '/published/shop',
    enable: false
  },
  RestaurantAndCafe: {
    itemColor: 'dashboard-color-2',
    headline: 'Restaurants & Cafes',
    headlineIco: 'icon-form-1',
    numberOfItems: '0',
    topInfo: '',
    bottomInfo: 'in 0 categories',
    url: '/Published/RestaurantAndCafe',
    enable: false
  },
  ServiceCompany: {
    itemColor: 'dashboard-color-2',
    headline: 'Service Companies',
    headlineIco: 'icon-form-1',
    numberOfItems: '0',
    topInfo: '',
    bottomInfo: 'in 0 categories',
    url: '/Published/ServiceCompany',
    enable: false
  },
  Service: {
    itemColor: 'dashboard-color-2',
    headline: 'Services',
    headlineIco: 'icon-form-1',
    numberOfItems: '0',
    topInfo: '',
    bottomInfo: '',
    url: '/published/service',
    enable: false
  },
  Parking: {
    itemColor: 'dashboard-color-2',
    headline: 'Parking',
    headlineIco: 'icon-form-1',
    numberOfItems: '0',
    topInfo: '',
    bottomInfo: 'in 0 categories',
    url: '/Published/Parking',
    enable: false
  },
  Offer: {
    itemColor: 'dashboard-color-1',
    headline: 'Offers',
    headlineIco: 'icon-player',
    numberOfItems: '0',
    topInfo: '0 offers',
    bottomInfo: '0 shops',
    url: '/published/offer',
    enable: false
  },
  Slideshow: {
    itemColor: 'dashboard-color-3',
    headline: 'Info Slideshows',
    headlineIco: 'icon-form-2',
    numberOfItems: '0',
    topInfo: '',
    bottomInfo: '',
    url: '/published/SlideShow',
    enable: false
  },
  SurroundingArea: {
    itemColor: 'dashboard-color-2',
    headline: 'Surrounding Area',
    headlineIco: 'icon-form-1',
    numberOfItems: '0',
    topInfo: '',
    bottomInfo: '',
    url: '/published',
    enable: false
  }
};
